import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Alert } from 'react-bootstrap-5';

import CompaniesTab from './companies/companies_tab';
import ContactPreview from 'components/contacts/contact_preview';
import PeopleTab from './people/people_tab';
import SearchPage from 'components/search_page';

import {
  endCallList,
  switchTab,
  toggleAlert,
  updateCallData,
  updatePreviewData
} from './store/actions/ui';

export class Contacts extends React.Component {
  static propTypes = {
    alertMessage: PropTypes.string,
    contactPreviewProps: PropTypes.object.isRequired,
    currentTab: PropTypes.oneOf(['companies', 'people']),
    error: PropTypes.bool,
    previewOverlayCallId: PropTypes.number,
    previewOverlayCallListId: PropTypes.number,
    previewOverlayRecordId: PropTypes.number,
    previewOverlayRecordType: PropTypes.string,
    previewOverlayTaskId: PropTypes.number,
    switchTab: PropTypes.func.isRequired,
    toggleAlert: PropTypes.func.isRequired,
    updatePreviewData: PropTypes.func.isRequired
  };

  static defaultProps = {
    currentTab: 'people'
  };

  handleDismiss = () => {
    this.props.toggleAlert("", false);
  }

  componentDidUpdate(prevProps) {
    const { alertMessage } = this.props;

    if (prevProps.alertMessage != alertMessage && alertMessage) {
      setTimeout(() => {
        this.handleDismiss();
      }, 6000);
    }
  }

  render() {
    const { alertMessage, error } = this.props;
    return (
      <>
        { alertMessage &&
          <Alert dismissible variant={error ? 'danger' : 'success'} onClose={this.handleDismiss}>
            <div className="ms-3">
              <span dangerouslySetInnerHTML={{ __html: alertMessage }} />
            </div>
          </Alert>
        }
        <SearchPage>
          <div className="results-tab-container">
            {this.renderActiveTab()}
          </div>
        </SearchPage>
        {this.renderPreviewOverlay()}
      </>
    );
  }

  renderActiveTab() {
    const { currentTab } = this.props;

    switch (currentTab) {
    case 'companies':
      return (
        <CompaniesTab name="companies-tab" />
      );
    case 'people':
      return (
        <PeopleTab name="people-tab" />
      );
    }
  }

  handleEndCallList = () => {
    const { contactPreviewProps, endCallList, previewOverlayCallId, updateCallData } = this.props;
    const { displayActions: { slideClose } } = contactPreviewProps;

    endCallList();
    updateCallData(previewOverlayCallId, null);
    window[slideClose]();
    sessionStorage.setItem("previewDisplay", false);
  }

  handleCycleTask = (record, task) => {
    const { updatePreviewData } = this.props;
    updatePreviewData(record.associatedModelId, record.associatedModelType, task.id);
  }

  handleStartCall = () => {
    const { previewOverlayCallListId, updateCallData } = this.props;
    updateCallData(true, previewOverlayCallListId);
  }

  handleEndCall = () => {
    const { previewOverlayCallListId, updateCallData } = this.props;
    updateCallData(null, previewOverlayCallListId);
  }

  renderPreviewOverlay = () => {
    const {
      contactPreviewProps,
      previewOverlayCallListId,
      previewOverlayRecordId,
      previewOverlayRecordType,
      previewOverlayTaskId
    } = this.props;

    const previewElement = document.querySelector(contactPreviewProps.querySelector);
    if (previewElement) {
      return ReactDOM.createPortal(
        <ContactPreview
          {...contactPreviewProps}
          callListId={previewOverlayCallListId}
          contactId={previewOverlayRecordId}
          contactType={previewOverlayRecordType}
          taskId={previewOverlayTaskId}
          onCycleTask={this.handleCycleTask}
          onEndCall={this.handleEndCall}
          onEndCallList={this.handleEndCallList}
          onStartCall={this.handleStartCall}
        />,
        previewElement
      );
    }
  }
}

export const propTypes = { ...Contacts.propTypes };

const mapStateToProps = state => ({
  currentTab: state.ui.currentTab,
  alertMessage: state.ui.alertMessage,
  error: state.ui.error,
  contactPreviewProps: state.ui.contactPreviewProps,
  previewOverlayCallId: state.ui.previewOverlayCallId,
  previewOverlayCallListId: state.ui.previewOverlayCallListId,
  previewOverlayRecordId: state.ui.previewOverlayRecordId,
  previewOverlayRecordType: state.ui.previewOverlayRecordType,
  previewOverlayTaskId: state.ui.previewOverlayTaskId
});

const mapDispatchToProps = {
  endCallList,
  switchTab,
  toggleAlert,
  updateCallData,
  updatePreviewData
};

export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
